export default (node) => {

  // get all button variants
  const productHandle = node.dataset.productHandle;
  const variants = JSON.parse(node.dataset.variants);
  const language = node.dataset.language == 'fr' ? '/fr' : '';

  const handleButtonVariantClick = async (e) => {
    const buttonVariant = e.currentTarget;
    let variantId = buttonVariant.dataset.productVariantId;
    const positionOption = buttonVariant.dataset.optionIndex
    const optionValue = buttonVariant.dataset.optionValue


    if (variantId.length === 0) {
      // let's find the first variant available with this option
      const variant = variants.find(variant => {
        return variant.options[positionOption] === optionValue;
      });
      if (variant) {
        variantId = variant.id;
      } else {
        return
      }
    }



    // fetch the product variant getting the section main-product
    try {
      const response = await fetch(`${language}/products/${productHandle}?variant=${variantId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      const responseText = await response.text();

      if (responseText) {
        updateProductOptions(responseText);


        // check if the option is the first option
        if (positionOption === "0") {
          document.dispatchEvent(
            new CustomEvent('new-option:change', {
              detail: {
                color: buttonVariant.dataset.optionValue,
              },
            })
          );
        }


        // update the URL with the new variant
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variantId);
        window.history.pushState({}, '', url.toString());
      }
    } catch (error) {
      console.error('Error:', error);
    }

  };

  const enforceSingleValueOptionVisibility = () => {
    if (node.dataset.hideSingleValueOptions !== 'true') return;

    node.querySelectorAll('.product-option').forEach((optionEl) => {
      const valueCount = optionEl.querySelectorAll('.option-values > li').length;
      optionEl.classList.toggle('hidden', valueCount <= 1);
    });
  };

  const updateProductOptions = (mainProduct) => {
    const parser = new DOMParser();
    const productElement = parser.parseFromString(mainProduct, 'text/html');

    const allVariants = document.querySelector('[data-component="newVariant"]');
    if (allVariants) {
      allVariants.innerHTML = productElement.querySelector('[data-component="newVariant"]').innerHTML;
      enforceSingleValueOptionVisibility();
      reinitEvents();
    }

    // update the label in stock/out of stock and add to cart button
    const labelStockInStockEl = document.querySelector('[data-labels-stock-wrapper]');
    const buttonAddToCart = document.querySelector('[data-cart-buttons]');
    if (labelStockInStockEl) {
      labelStockInStockEl.innerHTML = productElement.querySelector('[data-labels-stock-wrapper]').innerHTML;
    }
    if (buttonAddToCart) {
      buttonAddToCart.innerHTML = productElement.querySelector('[data-cart-buttons]').innerHTML;
    }

    sendCurrentVariant();
  };

  const sendCurrentVariant = () => {
    const newVariantId = document.querySelector('[button-add-to-cart]').getAttribute('data-variant-id');
    const isAvailable = document.querySelector('[button-add-to-cart]').getAttribute('button-add-to-cart-available');
    document.dispatchEvent(new CustomEvent('new-variant:change', {
      detail: {
        variant: newVariantId,
        available: isAvailable,
      },
    }));

    const paymentTerms = document.querySelector('.product-info__payment-terms');
    if (paymentTerms) {
      // get the name=id input element
      const idInput = paymentTerms.querySelector('input[name="id"]');
      if (idInput) {
        idInput.value = newVariantId;
        idInput.dispatchEvent(new Event("change", { bubbles: true }));
      }
    }
  };

  const reinitEvents = () => {
    const buttonVariants = node.querySelectorAll('[data-product-variant-id]');
    buttonVariants.forEach((buttonVariant) => {
      buttonVariant.addEventListener('click', handleButtonVariantClick);
    });
  };

  const init = () => {
    enforceSingleValueOptionVisibility();
    reinitEvents();
    sendCurrentVariant();
  };

  init();
}